import React, { Fragment } from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  ResponsiveContainer,
  LabelList,
  ComposedChart,
  Legend,
  CartesianGrid,
  Cell,
} from "recharts";

import {
  _formatNumber,
  _formatPrice,
  _isCoop,
} from "../../../../../../shared/helpers/utils";

const CustomBarChart = ({ theme, data, height = 300, buildingRes, style }) => {
  // Find the maximum value for dynamic Y-axis range
  const maxValue = Math.max(
    ...data.flatMap((item) => [
      item["Number of Sponsor Sales"] || 0,
      item["Number of Resales"] || 0,
    ])
  );

  const formatter = (tickValue) => {
    if (!tickValue) return tickValue;
    return _formatPrice(tickValue); 
  };

  return (
    <ResponsiveContainer
      height={height}
      width="100%"
    >
      <ComposedChart
        data={data}
        margin={{ top: 0, left: -10, bottom: 20, right: 20 }}
      >
        <YAxis
          axisLine={{ stroke: theme === "dark" ? "#f8ffef" : "#eee" }}
          tickLine={false}
          tick={{
            fill: theme === "dark" ? "#f8ffef" : "rgb(102, 102, 102)",
            fontSize: 20,
            fontWeight: 600,
          }}
          tickFormatter={formatter}
        />
        <XAxis
          dataKey="Year"
          tickLine={false}
          angle={45}
          tickSize={20}
          height={60}
          tickMargin={10}
          tick={{
            fill: theme === "dark" ? "#f8ffef" : "rgb(102, 102, 102)",
            fontSize: 20,
            fontWeight: 600,
          }}
        />
        {/* <Legend /> */}
        {_isCoop(buildingRes) ? (
          <Bar
            dataKey="Number of Sales"
            stackId="a"
            className="bar-element-chart"
            barSize={100}
            radius={[16, 16, 0, 0]}
            fill={theme === "dark" ? "#f8ffef" : "rgb(102, 102, 102)"}
          />
        ) : (
          <Fragment>
            <Bar
              dataKey="Number of Sponsor Sales"
              stackId="a"
              className="bar-element-chart"
              barSize={100}
              fill={theme === "dark" ? "#f8ffef" : "rgb(102, 102, 102)"}
            >
              {data.map(
                (entry, index) =>
                  entry["Number of Sponsor Sales"] !== 0 && (
                    <Cell
                      key={`cell-${index}`}
                      fill={theme === "dark" ? "#f8ffef" : "#fff"}
                    />
                  )
              )}
             <LabelList
            dataKey="total"
            position="top"
            className="bar-chart-label"
            style={{
              fontSize: 20,
              fontWeight: 700,
              
          
            }}
          />
            </Bar>
            <Bar
              dataKey="Number of Resales"
              stackId="a"
              barSize={100}
              fill="#D3A15D"
              className="bar-element-chart1"
           >
            {style==="style2"? null:  <LabelList
            dataKey="total"
            position="top"
            className="bar-chart-label"
            style={{
              fontSize: 20,
              fontWeight: 700,
              
          
            }}
          />}
           </Bar>
            
           
      
          </Fragment>
        )}
      </ComposedChart>
    </ResponsiveContainer>
  );
};

export default CustomBarChart;
